






import { Component, Vue } from 'vue-property-decorator';
import { Employee } from './api';
import AppPc from '@/AppPc.vue';
import AppMobile from '@/AppMobile.vue';
import QrcodeConfirmedIndex from '@/views/QrcodeConfirmedIndex.vue';
import { QrcodeIndexPathName, QrcodeIndexPath } from '@/common/index';
declare const EMPLOYEE: Employee;

@Component({ components: { AppPc, AppMobile, QrcodeConfirmedIndex } })
export default class App extends Vue {
  get isQrcodeIndex() {
    // 必须判断window.location.pathname，否则在跳转到扫码登录页面时无法正确显示
    return this.$route.name === QrcodeIndexPathName || window.location.pathname === QrcodeIndexPath;
  }

  get isMobile() {
    return this.$isMobile();
  }
}
